export class OrderNotification {
    public NotificationId: string;
    public OrderId: number;
}
